
import {
  MODAL_STATES,
  ACTIONS,
  MUTATIONS,
  GETTERS,
  STATES,
  PATHS
} from 'src/config/app'

export const mutations = {

    [MUTATIONS.setVersion]:(state, data) => {
      state.version.build = data.build
      state.version.date = data.date
    },


    // **************************************************
    //
    // LOADING
    //
    // **************************************************
    [MUTATIONS.setLoadProgress]:(state, progress) => {
      state.loading.progress = Math.min(progress, 1)
    },

    [MUTATIONS.setLoadStep]:(state, step) => {
      state.loading.step = step
      console.log('setLoadStep', step)
    },

    [MUTATIONS.setLoadComplete]:(state) => {
      state.loading.progress = 1
      state.loading.completed = true
    },

    // **************************************************
    //
    // ROUTE
    //
    // **************************************************
    [MUTATIONS.setAppState]:(state, app_state) => {
      window.router.replace({name:app_state}).catch(err => {})
      ////(will be set from router) state.app_state = app_state
    },

    [MUTATIONS.setModalState]:(state, modal_state) => {
      state.modal_state = modal_state
    },

    [MUTATIONS.setRoute]:(state, params) => {
      state.route.prev.parent = state.route.curr.parent
      state.route.prev.child = state.route.curr.child

      state.route.curr.parent = params.parent
      state.route.curr.child = params.child

      state.prev_app_state = state.app_state
      state.app_state = (params.child) ? params.child: params.parent;
    },


    [MUTATIONS.setRouteAfterLoad]:(state, value) => {
      console.log('setafterload', value)
      state.route.afterLoad = value
    },

   
}
